import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { postRequest } from '../../requestUtils';
import './ToggleUpcomingNotification.scss';

class ToggleUpcomingNotification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notify: props.notify,
      isExpanded: false,
    };

    this.showComments = this.showComments.bind(this);
    this.toggleNotification = this.toggleNotification.bind(this);
  }

  showComments() {
    this.setState((prevState) => ({ isExpanded: !prevState.isExpanded }));
  }

  toggleNotification() {
    const { id, csrfToken, toggleNotificationUrl } = this.props;
    const { notify } = this.state;

    postRequest(
      toggleNotificationUrl,
      { project_id: id },
      csrfToken,
    ).then(() => {
      this.setState({ notify: !notify });
    });
  }

  render() {
    const { notify, isExpanded } = this.state;

    return (
      <div className="consultant-upcoming-opportunity">
        <h2 className="project-action-header">
          Switch on the alert for this UPCOMING opportunity!
        </h2>

        <p className="project-action-description">
          Receive an email notification when this opportunity begins accepting applications.
        </p>

        <div
          onClick={() => this.toggleNotification()}
          role="button"
          tabIndex={0}
          className="body-text-2 medium-weight upcoming-opportunity-notification-toggle"
        >
          <i className={`fa${notify ? 's' : 'r'} fa-bell`} />
          <span>
            {`Email alert switched ${notify ? 'ON' : 'OFF'}`}
          </span>
          <div className="switch">
            <input
              type="checkbox"
              checked={notify}
              readOnly
            />
            <span className="slider round" />
          </div>
        </div>

        <hr className="d-none d-sm-block mb-4" />

        <h3>What is an upcoming opportunity?</h3>
        <div>
          <a
            className={`body-text-2 medium-weight ${isExpanded ? 'hide' : 'show'} upcoming-opportunity-read-more`}
            tabIndex={0}
            role="link"
            onClick={() => this.showComments()}
          >
            Read More
          </a>
        </div>
        <div className={`mt-8 body-text-2 ${isExpanded ? 'show' : 'hide'}`}>
          <div>
            It’s a project whose application process isn’t opened yet because the Employer and
            Clora are still fine-tuning final details.
            <h3 className="mt-40">When will I be able to apply?</h3>
            <div className="mt-8">
              Once the project becomes an Open Opportunity, you will be able to start the
              application process. If you switch on the alert, you will be instantly notified
              and become an early candidate.
            </div>
          </div>
          <div className="mt-8">
            <a
              className="medium-weight"
              tabIndex={0}
              role="link"
              onClick={() => this.showComments()}
            >
              Read Less
            </a>
          </div>
        </div>
      </div>
    );
  }
}

ToggleUpcomingNotification.propTypes = {
  id: PropTypes.number.isRequired,
  toggleNotificationUrl: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  notify: PropTypes.bool.isRequired,
};

export default ToggleUpcomingNotification;
